import { SvgIconComponent } from '@mui/icons-material';
import classNames from 'classnames';
import * as React from 'react';
import { VFC } from 'react';
import './MacroIcon.css';

export interface MacroIconProps {
  icon: SvgIconComponent;
  align?: 'left' | 'right';
  hover?: boolean;
  active?: boolean;
  onClick?: () => void;
}

export const MacroIcon: VFC<MacroIconProps> = (props) => {
  const classes = classNames({
    'macro-icon': true,
    'is-hoverable': Boolean(props.hover),
    'is-clickable': Boolean(props.onClick),
    'is-active': Boolean(props.active),
    'on-left': props.align === 'left',
    'on-right': props.align === 'right',
  });

  return (
    <div className={classes} onClick={props.onClick}>
      <props.icon fontSize="large" />
    </div>
  );
};
